<span style="font-size: 1.2em; font-weight: bold;" class="d-block">{{ step4.getobjetprincipal | translate }}</span>
<br />

<app-typeCPV-class [uid]="getUid() + '_objetPrincipal'" [parentForm]="parentForm" [disabled]="disabled"
  [objetComplementaire]="cpv?.objetPrincipal"></app-typeCPV-class>
